import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tree, Checkbox, Col, Spin, Popover, Tooltip } from 'antd';
import { callApi } from 'utils';
import { UserOutlined, FolderOpenOutlined, FolderOutlined, SkinOutlined, TagOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import departmentManager from '../../images/department_manager.png';
import departmentSuperior from '../../images/department_superior.png';
import './index.less';
import { all } from 'browser-cookies';

const TreeNode = Tree.TreeNode;
const prefixClx = 'new-select-modal-applier';

class SelectApplierRelated extends Component {
	constructor (props) {
		super(props);
		this.state = {
			loading: false,
			treeData: {},
			expandedKeys: [],
			positions: [],
		};
	}

	componentDidMount () {
		this.setState({
			loading: true
		});
		Promise.all([this.initList(), this.listPositionGroup(), this.listJobPositionPageable()]).then(([res, res1, res2]) => {
			const { positionList = [] } = res2;
			const groups = res1.map(item => ({
				...item,
				isGroup: true,
				childGroupList: undefined
			}))
			this.setState({ 
				treeData: res,
				positions: [...groups, ...positionList],
				loading: false
			});

		}).catch(() => {
			this.setState({ 
				loading: false
			});
		})
	}

	//获取岗位分组
	listPositionGroup = () => {
		return callApi({
			api: '/org_v6/listPositionGroup',
			data: {
				organizationId: window.$$context.organizationId
			},
			success: (res) => {
			},
			complete: () => {
			}
		});
		
	}
	listJobPositionPageable = () => {
		return callApi({
			api: '/org_v6/listJobPositionPageable',
			data: {
				organizationId: window.$$context.organizationId,
				pageSize: 999,
				pageAnchor: 1
			},
			success: () => {
			},
			complete: () => {
			}
		});
	}

	/**
	 * 获取列表
	 */
	initList = () => {
		const { flowVariableType } = this.props;
		
		const api = '/admin/flow/listApplierVariables';
		const data = {
			flowVariableType,
			organizationId: window.$$context.organizationId,
		};
		return callApi({
			api,
			data,
			success: (res) => {
			},
			complete: () => {
			}
		});
	}

	// 生成树节点
	generateNodes = (data) => {
		// locationType: 工作流场景，personal_center - 园区服务、task_management - 内部办公
		const { locationType = 'personal_center' } = this.props;
		const nodes = [];
		this.generateVariableNodes(data, nodes);
		// 在内部办公场景添加发起人所在部门相关的岗位和标签
		if (locationType === 'task_management') {
			this.generateDepartmentNodes(data, nodes, 'source_user_all_department');
			this.generateDepartmentNodes(data, nodes, 'source_user_primary_department');
			this.generateDepartmentNodes(data, nodes, 'form_value_department');
		}

		return nodes;
	}

	// 生成变量相关的节点
	generateVariableNodes = (data, nodes) => {
		// locationType: 工作流场景，personal_center - 园区服务、task_management - 内部办公
		const { selects = [], disabledSelects = [], locationType = 'personal_center', nodeType , customNo} = this.props;
		const { flowVars = [], } = data;
		// showType：使用场景，0 - 隐藏、1 - 内部办公、2 - 园区服务、3 - 都可见 
		// nodeWhiteList：可用的节点类型白名单，有值时，需要进行过滤
		flowVars.filter(item => {
			const { showType = 3, nodeWhiteList = [] } = item;
			if (nodeWhiteList.length && nodeType && !nodeWhiteList.includes(nodeType)) return false;
			if (locationType === "personal_center") {
				return showType === 2 || showType === 3;
			  }
	
			  return showType === 1 || showType === 3;
		}).forEach(item => {
			const { id, label } = item
			const sourceTypeA = 'source_variable';
			const selected = selects.some(node => node.sourceTypeA === sourceTypeA && node.sourceIdA === id);
			const disabled = disabledSelects.some(node => node.sourceTypeA === sourceTypeA && node.sourceIdA === id);
			const itemData = {
				selectionName: label,
				flowUserSelectionType: 'variable',
				sourceIdA: id,
				sourceTypeA,
			};
		    const isLeaf = item.name == 'user_appier' && item.varType == 'node_user_processor';
			const treeNode = (
				<TreeNode
					key={`variable-${id}`}
					disabled={disabled}
					itemData={itemData}
					icon={<UserOutlined />}
					selectable
					isLeaf
					title={(
						<div className={`${prefixClx}-node`}>
							<span className={`${prefixClx}-node-name`}>{label}</span>
							<span className={`${prefixClx}-node-handle`}>
								<Checkbox checked={selected} />
							</span>
						</div>
					)}
				/>
			);
			nodes.push(treeNode);
		});
	}

	getNodePrefixName = (sourceTypeB) => {
		let prefixName = '';
		switch (sourceTypeB) {
			case 'source_user_all_department':
				prefixName = '发起人所在部门的';
				break;
			case 'source_user_primary_department':
				prefixName = '发起人主部门的';
				break;
			case 'form_value_department':
				prefixName = '发起人指定部门的';
				break;
			default:
				prefixName = '发起人所在部门的';
		}
		return prefixName;
	}

	getParentNodeTitle = (sourceTypeB, basicTitle) => sourceTypeB === 'form_value_department'
		? <React.Fragment>
			<span>{basicTitle}</span>
			<Tooltip title="使用此变量时，请在表单中新增单选字段，并设置选项来源为“部门选择器”" className={`${prefixClx}-parent`}>
				<QuestionCircleOutlined/>
			</Tooltip>
		</React.Fragment>
		: basicTitle;

	// 生成所在部门相关的节点
	generateDepartmentNodes = (data, nodes, sourceTypeB) => {
		const { expandedKeys } = this.state;
		const prefixName = this.getNodePrefixName(sourceTypeB);

		// 岗位的节点
		const positionNodes = this.generatePositionNodes(data, sourceTypeB);

		const nodeKey1 = `${sourceTypeB}-position`;

		const treeNode1 = (
			<TreeNode
				key={nodeKey1}
				selectable={false}
				icon={expandedKeys.includes(nodeKey1) ? <FolderOpenOutlined /> : <FolderOutlined />}
				title={this.getParentNodeTitle(sourceTypeB, `${prefixName}岗位`)}
			>
				{positionNodes}
			</TreeNode>
		);
		nodes.push(treeNode1);

		// 标签的节点
		const labelNodes = this.generateLabelNodes(data, sourceTypeB);

		const nodeKey2 = `${sourceTypeB}-label`;
		const treeNode2 = (
			<TreeNode
				key={nodeKey2}
				selectable={false}
				icon={expandedKeys.includes(nodeKey2) ? <FolderOpenOutlined /> : <FolderOutlined />}
				title={this.getParentNodeTitle(sourceTypeB, `${prefixName}标签`)}
			>
				{labelNodes}
			</TreeNode>
		);
		nodes.push(treeNode2);
	}

	// 生成岗位相关的节点
	generatePositionNodes = (data, sourceTypeB) => {
		const { selects = [], disabledSelects = [] } = this.props;
		const { expandedKeys, positions = [] } = this.state;
		const { managers = [], superiors = [] } = data;
		const prefixName = this.getNodePrefixName(sourceTypeB);
		const positionNodes = [];
		// 生成部门管理相关的节点
		const generateManagerNodes = (list, type) => {
			const nodeKey = `${sourceTypeB}-${type}`;
			const sourceTypeA = 'source_variable';
			// 转成想要的数据格式
			const nodeList = list.map(item => ({
				label: item.label,
				selectionName: prefixName + item.label,
				flowUserSelectionType: 'variable',
				sourceIdA: item.id,
				sourceTypeA,
				sourceTypeB,
				sourceIdB: 0
			}));
			// 整个组是否全选
			const selectedAll = nodeList.every(item => {
				return selects.some(node => node.sourceTypeA === sourceTypeA && node.sourceIdA === item.sourceIdA && node.sourceTypeB === sourceTypeB);
			});
			const popoverContent = (
				<div className={`${prefixClx}-pop-content`}>
					<img src={type === 'major' ? departmentManager : departmentSuperior} alt=""/>
				</div>
			);
			const managerNode = (
				<TreeNode
					key={nodeKey}
					selectable={false}
					icon={expandedKeys.includes(nodeKey) ? <FolderOpenOutlined /> : <FolderOutlined />}
					title={(
						<div className={`${prefixClx}-node`}>
							<span className={`${prefixClx}-node-name`}>
								<span>{type === 'major' ? '部门主管' : '部门分管'}</span>
								<Popover
									overlayClassName={`${prefixClx}-pop-container`}
									content={popoverContent}
									placement="bottom"
									trigger="hover"
									overlayStyle={{ width: 300 }}
								>
									<QuestionCircleOutlined />
								</Popover>
							</span>
							<span className={`${prefixClx}-node-handle select-all`} onClick={() => this.changeGroupSelectAll(nodeList, selectedAll)}>
								{selectedAll ? '取消全选' : '全选'}
							</span>
						</div>
					)}
				>
					{nodeList.map(item => {
						const { sourceIdA, label } = item;
						const selected = selects.some(node => node.sourceTypeA === sourceTypeA && node.sourceIdA === sourceIdA && node.sourceTypeB === sourceTypeB);
						const disabled = disabledSelects.some(node => node.sourceTypeA === sourceTypeA && node.sourceIdA === sourceIdA && node.sourceTypeB === sourceTypeB);
						return (
							<TreeNode
								key={`${sourceTypeB}-${type}-${sourceIdA}`}
								disabled={disabled}
								itemData={item}
								icon={<SkinOutlined />}
								selectable
								title={(
									<div className={`${prefixClx}-node`}>
										<span className={`${prefixClx}-node-name`}>{label}</span>
										<span className={`${prefixClx}-node-handle`}>
											<Checkbox checked={selected} />
										</span>
									</div>
								)}
							/>
						);
					})}
				</TreeNode>
			);
			positionNodes.push(managerNode);
		};
		generateManagerNodes(managers, 'major');
		generateManagerNodes(superiors, 'minor');

		const generateNormalPositionNodes = (data = []) => {
			const nodes = data.map(item => {
				const { id, name, childGroupList, positionList, isGroup, parentId } = item;
				const sourceTypeA = 'source_position';
				const selected = selects.some(node => node.sourceTypeA === sourceTypeA && node.sourceIdA === id && node.sourceTypeB === sourceTypeB);
				const disabled = disabledSelects.some(node => node.sourceTypeA === sourceTypeA && node.sourceIdA === id && node.sourceTypeB === sourceTypeB);
				const itemData = {
					selectionName: prefixName + name,
					flowUserSelectionType: 'position_new',
					sourceIdA: id,
					sourceTypeA,
					sourceTypeB,
					sourceIdB: 0
				};
				const positionNode = !isGroup ? (
					<TreeNode
						key={`${sourceTypeB}-position-${parentId}-${id}`}
						disabled={disabled}
						itemData={itemData}
						icon={<SkinOutlined />}
						isLeaf={true}
						selectable
						title={(
							<div className={`${prefixClx}-node`}>
								<span className={`${prefixClx}-node-name`}>{name}</span>
								<span className={`${prefixClx}-node-handle`}>
									<Checkbox checked={selected} />
								</span>
							</div>
						)}
					/>
				): (
					<TreeNode
					key={`${sourceTypeB}-position-group-${id}`}
					disabled={disabled}
					itemData={itemData}
					allData = {item}
					isLeaf={false}
					icon={expandedKeys.includes(`${sourceTypeB}-position-group-${id}`) ? <FolderOpenOutlined /> : <FolderOutlined />}
					selectable
					title={(
						<div className={`${prefixClx}-node`}>
							<span className={`${prefixClx}-node-name`}>{name}</span>
						</div>
					)}
				>
					{
						childGroupList && generateNormalPositionNodes(childGroupList)
					}
					{positionList && generateNormalPositionNodes(positionList)}
				</TreeNode>
				);
				// positionNodes.push(positionNode);
				return positionNode;
			});
			return nodes;
		}
		positionNodes.push(generateNormalPositionNodes(positions));

		return positionNodes;
	}

	lazyLoadData = ({ children, allData }) => {
		if (children) {
			return Promise.reject();;
		}
		return callApi({
			api: '/org_v6/getCurrentPositionGroup',
			data: {
				organizationId: window.$$context.organizationId,
				parentId: allData?.id
			},
			success: (res) => {
				const { positionList = [], childGroupList=[]} = res;
				const newGroup = childGroupList.map(item => ({
					...item,
					isGroup: true
				}))
				Object.assign(allData, {positionList},{childGroupList: newGroup})
				this.setState(({positions}) => ({
					positions
				}))
			},
			complete: () => {
			}
		});
	}

	// 生成标签相关的节点
	generateLabelNodes = (data, sourceTypeB) => {
		const { selects = [], disabledSelects = [] } = this.props;
		const { expandedKeys } = this.state;
		const { labelGroups = [] } = data;
		const prefixName = this.getNodePrefixName(sourceTypeB);
		const sourceTypeA = 'source_label';
		const labelNodes = labelGroups.map(group => {
			const { id: groupId, name: groupName, labels = [] } = group;
			const nodeKey = `${sourceTypeB}-label-${groupId}`;
			// 转成想要的数据格式
			const nodeList = labels.map(item => ({
				label: item.name,
				selectionName: prefixName + item.name,
				flowUserSelectionType: 'label',
				sourceIdA: item.id,
				sourceTypeA,
				sourceTypeB,
				sourceIdB: 0
			}));
			// 整个组是否全选
			const selectedAll = nodeList.every(item => {
				return selects.some(node => node.sourceTypeA === sourceTypeA && node.sourceIdA === item.sourceIdA && node.sourceTypeB === sourceTypeB);
			});
			return (
				<TreeNode
					key={nodeKey}
					selectable={false}
					icon={expandedKeys.includes(nodeKey) ? <FolderOpenOutlined /> : <FolderOutlined />}
					title={(
						<div className={`${prefixClx}-node`}>
							<span className={`${prefixClx}-node-name`}>{groupName}</span>
							<span className={`${prefixClx}-node-handle select-all`} onClick={() => this.changeGroupSelectAll(nodeList, selectedAll)}>
								{selectedAll ? '取消全选' : '全选'}
							</span>
						</div>
					)}
				>
					{nodeList.map(item => {
						const { sourceIdA, label } = item;
						const selected = selects.some(node => node.sourceTypeA === sourceTypeA && node.sourceIdA === sourceIdA && node.sourceTypeB === sourceTypeB);
						const disabled = disabledSelects.some(node => node.sourceTypeA === sourceTypeA && node.sourceIdA === sourceIdA && node.sourceTypeB === sourceTypeB);
						return (
							<TreeNode
								key={`${sourceTypeB}-label-${groupId}-${sourceIdA}`}
								disabled={disabled}
								itemData={item}
								icon={<TagOutlined />}
								selectable
								title={(
									<div className={`${prefixClx}-node`}>
										<span className={`${prefixClx}-node-name`}>{label}</span>
										<span className={`${prefixClx}-node-handle`}>
											<Checkbox checked={selected} />
										</span>
									</div>
								)}
							/>
						);
					})}
				</TreeNode>
			);
		});
		return labelNodes;
	}

	onExpand = (keys) => {
		this.setState({ expandedKeys: keys });
	};

	onSelect = (selectedKeys, data) => {
		const { selects, addItems, removeItems } = this.props;
		const itemData = data.node.itemData;
		const { sourceTypeA, sourceIdA, sourceTypeB } = itemData;
		const selected = selects.some(node => node.sourceTypeA === sourceTypeA && node.sourceIdA === sourceIdA && node.sourceTypeB === sourceTypeB);
		if (selected) {
			removeItems([itemData]);
		} else {
			addItems([itemData]);
		}
	}

	// 改变某个组的全选
	changeGroupSelectAll = (groupList, selectedAll) => {
		const { selects, addItems, removeItems } = this.props;
		if (selectedAll) {
			// 找出已选中的，并删除
			const removeList = groupList.filter(item => {
				return selects.some(node => node.sourceTypeA === item.sourceTypeA && node.sourceIdA === item.sourceIdA && node.sourceTypeB === item.sourceTypeB);
			});
			removeItems(removeList);
		} else {
			// 找出还未选中的，并添加
			const addList = groupList.filter(item => {
				return !selects.some(node => node.sourceTypeA === item.sourceTypeA && node.sourceIdA === item.sourceIdA && node.sourceTypeB === item.sourceTypeB);
			});
			addItems(addList);
		}
	}

	render () {
		const { loading, treeData, expandedKeys } = this.state;
		const treeNodes = this.generateNodes(treeData);
		return (
			<Col className='tree-box scroll-tree-box'>
				<div className={`${prefixClx}-title`}>选择发起人相关</div>
				<div className={`${prefixClx}-view select-scroll-view`}>
					{loading
						? (
							<Spin spinning>
								<div style={{ height: 300 }} />
							</Spin>
						)
						: (
							<Tree
								className={`${prefixClx}-tree`}
								multiple
								selectable
								blockNode
								showIcon
								expandedKeys={expandedKeys}
								onExpand={this.onExpand}
								onSelect={this.onSelect}
								loadData={this.lazyLoadData}
							>
								{treeNodes}
							</Tree>
						)}
				</div>
			</Col>
		);
	}
}

SelectApplierRelated.propTypes = {
	// 组织架构数据
	organizations: PropTypes.object.isRequired,
	organizationId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),

	/* 以下是configs额外传进来的参数 */
	// 扩展的树节点，格式为 [{id: -1, name: '不限部门', type: 'source_unlimited_department', childrens: [...]}]
	extendTree: PropTypes.array,
	disabledSelects: PropTypes.array,
	selects: PropTypes.array,
	addItems: PropTypes.func.isRequired,
	removeItems: PropTypes.func.isRequired,
};

export default SelectApplierRelated;
